import {default as _ } from 'lodash';
import { Injectable } from "@angular/core";
import { APIURL } from "app/Shared/Constant/API_Urls";
import { GridService } from "app/Shared/Services/grid.service";
import { ConstantService } from "app/Shared/Services/constant-service";
import { SharedHttpClientService } from "app/Shared/Services/shared-http-client.service";
import { UrlsService } from "app/Shared/Services/urls.service";
import { UserService } from "app/Shared/Services/user.service";
import { map } from 'rxjs/operators';

@Injectable()
export class EventTreeService {
    dataArray: any=[]; 
    isDialogOpen:any= false;
    NONCATFields: any = ['fileID', 'reportDate', 'rsmsStatus', 'errorCodeList', 'createDate', 'updateDate', 'lastUpdatedBy', 'groupName'];

    constructor(private gridService: GridService,
        private sharedHttpClientService: SharedHttpClientService,
        private urlsService: UrlsService,
        private userService: UserService,
        public constantService: ConstantService) {
      }

    getData(rowData:any, callType:any,startLimit:any,endLimit:any) {
        let row = rowData;
        let todate = row['reportDate'];
        let orderID = row['orderID'];
        let type = row['type'];
        let firmROEID = row['firmROEID'];
        let symbol = row['symbol'];
        let orderKeyDate = row['orderKeyDate'];
        let searchParent = row['searchParent'];

        if (callType == "parent") {
          if (row['priorOrderKeyDate'] != "" && row['priorOrderKeyDate'] != null) {
            todate = row['priorOrderKeyDate'];
          } else if (row['parentOrderKeyDate'] != "" && row['parentOrderKeyDate'] != null) {
            todate = row['parentOrderKeyDate'];
          } else if (row['orderKeyDate'] != "" && row['orderKeyDate'] != null) {
            todate = row['orderKeyDate'];
          }
    
          if (row['priorOrderID'] != "" && row['priorOrderID'] != null) {
            orderID = row['priorOrderID'];
          } else if (row['parentOrderID'] != "" && row['parentOrderID'] != null) {
            orderID = row['parentOrderID'];
          } else if (row['orderID'] != "" && row['orderID'] != null) {
            orderID = row['orderID'];
          }
    
          if (type == "MEOT" || type == "MOOT") {
            orderID = row['sellOrderID'];
            if (orderID == "")
              orderID = row['buyOrderID'];
          }
          if (type == "MEOF" || type == "MOOF") {
            orderID = row['firmOrderID'];
            if (orderID == "")
              orderID = row['clientOrderID'];
          }    
        }

        if(row['type'].startsWith("ME")) {
          symbol = row['symbol'];
        } else if(row['type'].startsWith("MO")) {
          symbol = row['optionID'];
        } else if(row['type'].startsWith("ML")) {
          symbol = row['underlying'];
        }

        if(['MENQ', 'MEQR'].includes(row['type'])) {
          orderKeyDate = row['quoteKeyDate'];
        } else if(['MEAA', 'MEPA', 'MOAA', 'MOPA'].includes(row['type'])) {
          orderKeyDate = row['allocationKeyDate'];
        } else if(['MEFA','MEOF','MOFA','MOOF'].includes(row['type'])) {
          orderKeyDate = row['fillKeyDate'];
        } else if(['MEOT','MOOT'].includes(row['type'])) {
          orderKeyDate = row['tradeKeyDate'];
        }

        let payload = {
          mpid: this.userService.getActiveMPID(),
          orderID: orderID,
          todate: todate,
          type: type,
          firmROEID: firmROEID,
          symbol: symbol,
          orderKeyDate: orderKeyDate,
          callType: callType,
          searchParent: searchParent,
          startLimit:startLimit,
          endLimit:endLimit
        };
    
        return this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.Order_Viewer_tree_data), payload)
          .pipe(map((response: Response) => {
            return response;
          }))
      }

  processUniqueFields(resultData: any) {
    const eventTypes :any = Array.from(new Set(resultData.map((item:any) => item.type)));

    const eventTypesFields: any[] = [];
    if(eventTypes.length > 0) {
      for(let i = 0; i < eventTypes.length; i++) {
        const eventTypeGridCols = this.gridService.prepareQuickviewPanel(eventTypes[i].toString());
        eventTypesFields.push(...eventTypeGridCols);
      }
    }

    const uniqueEventTypeFields = [];
    for( let j = 0; j < eventTypesFields.length; j++ ) {
      if(uniqueEventTypeFields.length > 0) {
        let isEventTypeFieldAvailable = uniqueEventTypeFields.filter(etfObj => etfObj.ui_columnname===eventTypesFields[j].ui_columnname);
        if(isEventTypeFieldAvailable.length===0) {
          uniqueEventTypeFields.push(eventTypesFields[j]);
        }
      } else {
        uniqueEventTypeFields.push(eventTypesFields[j]);
      }
    }

    // Filter CAT Fields & eliminates Non-CAT Fields
    const catEventTypeFields = uniqueEventTypeFields.filter(uetfObj => !_.includes(this.NONCATFields, uetfObj.ui_columnname));

    // Sort All CAt Fields by ColumnNames
    catEventTypeFields.sort((a, b) => {
      let fa = a.ui_columnname.toLowerCase(), fb = b.ui_columnname.toLowerCase();
      return ((fa < fb) ? -1 : ((fa > fb) ? 1 : 0));
    });

    return catEventTypeFields;
  }

  exportToCSV(eventTreeData:any) {
    this.dataArray = [];

    this.prepareData(eventTreeData);

    return this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(APIURL.CAT_EXPORT_CSV),
      {"CSVExportData": JSON.parse(JSON.stringify(this.dataArray))}
    ).pipe(map((response: Response) => {
        return response;
    }));
  }

prepareData(eventTreeData:any) {
    for (let node of eventTreeData) {
        const data:any=node.data;
        const childData:any=node.children;
        this.dataArray.push(data)
      if (childData) {
        this.prepareData(childData);
      }
    }
}

    
}